import { render, staticRenderFns } from "./S12UiFixed.vue?vue&type=template&id=1a4f1980&scoped=true&"
import script from "./S12UiFixed.vue?vue&type=script&lang=js&"
export * from "./S12UiFixed.vue?vue&type=script&lang=js&"
import style0 from "./S12UiFixed.vue?vue&type=style&index=0&id=1a4f1980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4f1980",
  null
  
)

export default component.exports